module.exports = __webpack_public_path__ + "img/9-full-lg.0903b1a3.jpg";